import { BaseCategory } from "./BaseCategory";
import { AuthoringBlockType, HeaderPositionType, ListStyleType, TextStyleType } from "../constants";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";
import { v4 as uuid } from "uuid";

export class AgendaCategory extends BaseCategory {
    get name() {
        return "Agenda";
    }

    get type() {
        return SlideCategories.AGENDA;
    }

    get icon() {
        return null;
    }

    get description() {
        return `The content specifically describes an agenda or meeting schedule.`;
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Parse the content to determine the agenda items or topics to be covered. List the main items in order. If there are sub-items or descriptions for each main item, include those. Separate any additional content into the conclusion`;
    }

    getImagePrompt() {
        return false;
    }

    getPromptSchema(options = {}) {
        return {
            items: this.getItemListSchema(options),
            conclusion: "an optional short conclusion or takeaway for the slide",
        };
    }

    getSlideModels(model, options = {}) {
        return [this.buildSingleColumnAgenda(model, options)];
    }

    buildSingleColumnAgenda(model, options = {}) {
        let builder = new SlideModelBuilder("agenda", model);
        builder.createHeader({ heading: model.slideTitle, position: HeaderPositionType.TOP });

        const blocks = [];

        // Create agenda items as numbered list blocks
        model.items.forEach(item => {
            // Main item block
            const mainBlock = {
                type: AuthoringBlockType.TEXT,
                textStyle: TextStyleType.BULLET_LIST,
                listStyle: ListStyleType.NUMBERED,
                html: item.title,
                indent: 0,
            };

            blocks.push(mainBlock);

            // Add description/sub-items if present
            if (item.description) {
                const descriptionBlock = {
                    type: AuthoringBlockType.TEXT,
                    textStyle: TextStyleType.BULLET_LIST,
                    listStyle: ListStyleType.TEXT,
                    html: item.description,
                    indent: 1,
                };
                blocks.push(descriptionBlock);
            }
        });

        // Create a single column with all blocks
        const primary = {
            items: [
                {
                    id: uuid(),
                    isMedia: false,
                    text: {
                        blocks: blocks
                    }
                }
            ],
            autoDistributeBullets: false,
            autoArrangeColumnsCount: 1,
            showColumnHeaders: false,
            startNum: 1,
            listStyle: ListStyleType.NUMBERED,
        };

        builder.createPrimary(primary);

        if (options.citeSources) {
            builder.createSourcesAttribution(model.sources);
        }

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion);
        }

        return builder.model;
    }
}
